import { useCallback } from 'react';
import { useLogAnalyticsEvent } from '../../../hooks';
import { useAtomicScreen } from '../context/AtomicScreenContext';

/**
 * AtomicRenderer 탑 버튼 클릭 로깅 — `CLICK_SCROLL_TO_TOP`.
 *
 * SCREEN 은 `AtomicScreenContext` 에서 얻는다(`logOnPressItem` 과 같은 규칙 — context 가
 * 없으면 넘기지 않고 `useLogAnalyticsEvent` 가 머지하는 값에 맡긴다).
 *
 * 채널은 같은 이벤트를 쏘는 다른 경로들과 맞춘다(`useNativeScrollToTop`,
 * 홈 `useLogClickScrollToTop`).
 *
 * 홈 탭(HomeAtomic/TodayAtomic)은 `hideScrollToTop` 으로 이 버튼을 숨기고 자체 플로팅
 * 버튼을 쓰므로 발화가 겹치지 않는다.
 */
export const useLogClickScrollToTop = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  const screen = useAtomicScreen();

  return useCallback(() => {
    logAnalyticsEvent({
      channel: ['ablylog', 'amplitude', 'firebase'],
      name: 'CLICK_SCROLL_TO_TOP',
      ...(screen != null && { analytics: { SCREEN: screen } }),
    });
  }, [logAnalyticsEvent, screen]);
};
